export const BLUE = '#1B97C2';
export const DARK_BLUE = '#157495';
export const RED = '#D32F2F';
export const ORANGE = '#FFA726';
export const GREEN = '#4DB6AC';
export const GREEN_MAIN = '#009688';